import { MyFarmersDto } from "api/dtos/MyFarmersDto";
import { USER_ROLES } from "../../constants/userRoles";
import axiosInstance from "../utils/axiosInstance";
import { URLS } from "../utils/baseUrls";

const getFarmers = (params = { regionId: undefined }) => {
  const { regionId } = params;
  const config = { ...(regionId ? { params } : {}) };

  return axiosInstance.get(`${URLS.users}/farmers/`, config);
};

const getFarmersForKyd = async () => {
  try {
    const res = await axiosInstance.get(`${URLS.users}/farmers/my-farmers/`);
    const farmers = MyFarmersDto.fromApi(res.data);
    return farmers;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const getUser = (id, role = USER_ROLES.FARMER) => {
  if (role === USER_ROLES.AGRONOMIST) {
    return axiosInstance.get(`${URLS.users}/agronomists/${id}/`);
  } else if (role === USER_ROLES.FARMER) {
    return axiosInstance.get(`${URLS.users}/farmers/${id}/`);
  }
};

const getUserByUserId = (userId) => {
  return axiosInstance.get(`${URLS.users}/user/${userId}/`);
};

/**
 * @param {Object} params - The request parameters.
 * @param {string} params.query - The search query param to filter.
 * @param {any[]} params.regions - A list of regions ids to filter.
 */
const getAvailableFarmers = (params) => {
  const finalParams = new URLSearchParams();

  const { query, regions } = params || {};
  if (query) {
    finalParams.append("query", query);
  }
  if (regions && regions.length > 0) {
    const finalRegions = regions.map((region) => region.value).join(",");
    finalParams.append("regions", finalRegions);
  }
  return axiosInstance.get(`${URLS.search}/farmer-fields/`, {
    params: finalParams,
  });
};

/**
 * @param {Object} params - The request parameters.
 * @param {string} params.query - The search query param to filter.
 * @param {any[]} params.regions - A list of regions ids to filter.
 */
const getAvailableAgronomists = (params) => {
  const { query, regions } = params || {};
  const finalParams = new URLSearchParams();
  if (query) {
    finalParams.append("icontains", [query]);
  }
  if (regions && regions.length > 0) {
    finalParams.append(
      "region",
      regions.map((region) => JSON.stringify({ id: region.value })),
    );
  }

  // return axiosInstance.get(`${URLS.search}/agronomist-field/query/execute/`, {
  // params: finalParams,
  // });
  return axiosInstance.get(`${URLS.users}/agronomists/`);
};

const getUserConsents = () => {
  return axiosInstance.get(`${URLS.consents}/`);
};
const updateUserConsent = (consentName) => {
  return axiosInstance.post(`${URLS.consents}/`, { name: consentName });
};

export const usersApi = {
  fetchOne: getUser,
  fetchFarmers: getFarmers,
  fetchMyFarmers: getFarmersForKyd,
  availableFarmers: getAvailableFarmers,
  availableAgronomists: getAvailableAgronomists,
  fetchUserConsents: getUserConsents,
  updateUserConsent,
  getUserByUserId,
};
